// Types
import { APIAction } from 'types'

// Utils
import { user } from 'normalize'

export const actions = {
  fetchUser: (userId: number): APIAction => ({
    CALL_API: {
      type: 'FETCH_USER',
      method: 'GET',
      endpoint: `/api/user/${userId}/`,
      requestKey: userId,
      schema: user,
    },
  }),
}
